var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#00ff00",
    stroke: "#000000",
    strokeWidth: 1,
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 26.349 26.35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 13.792,
    cy: 3.082,
    r: 3.082
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.792,
    cy: 24.501,
    r: 1.849
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.219,
    cy: 6.218,
    r: 2.774
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.365,
    cy: 21.363,
    r: 1.541
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.082,
    cy: 13.792,
    r: 2.465
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.501,
    cy: 13.791,
    r: 1.232
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.694,19.84c-0.843,0.843-0.843,2.207,0,3.05c0.842,0.843,2.208,0.843,3.05,0c0.843-0.843,0.843-2.207,0-3.05 C6.902,18.996,5.537,18.988,4.694,19.84z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.364,
    cy: 6.218,
    r: 0.924
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.2760b4d5c8e0b1f0ad25715355c88d02.svg";
export { ForwardRef as ReactComponent };